import React, { useState, useMemo } from 'react';
import Slider from 'react-slick';
import { truncateText } from 'helpers';
import NewsModal from 'components/News/NewsModal';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const NewsSlide = ({ news }) => {
  const randomizedNews = useMemo(() => {
    if (!news || news.length === 0) return [];
    const shuffled = [...news];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }, [news]);

  const [selectedNewsId, setSelectedNewsId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    centerMode: true,
    initialSlide: 0,
    pauseOnFocus: true,
    pauseOnHover: true,
    speed: 700,
    className: 'newsSlide',
  };

  const handleNewsClick = (newsItem, event) => {
    event.preventDefault();

    // Detect search engine crawlers
    const isBot =
      /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|linkedinbot|whatsapp|telegrambot|applebot|ia_archiver|archive.org_bot|semrushbot|ahrefsbot|mj12bot|dotbot|crawler|spider|bot/i.test(
        navigator.userAgent
      );

    // If this is third-party URL, open in new tab
    const isThirdParty = newsItem.news_url && !newsItem.news_content;
    if (isThirdParty) {
      window.open(newsItem.news_url, '_blank');
      return;
    }

    // If it's a bot, navigate directly to the article page for SEO
    if (isBot) {
      window.location.href = `/news/${newsItem.news_id}`;
      return;
    }

    // Otherwise show modal with content (for human users)
    setSelectedNewsId(newsItem.news_id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const removeCitations = (text) => {
    if (!text) return text;
    return text.replace(/\[\d+\]/g, '').trim();
  };

  return (
    <>
      <Slider {...settings}>
        {randomizedNews.map((newsItem) => (
          <button
            key={newsItem.news_id}
            onClick={(e) => handleNewsClick(newsItem, e)}
            style={{
              background: 'none',
              border: 'none',
              color: 'inherit',
              cursor: 'pointer',
              padding: 0,
              textAlign: 'left',
              width: '100%',
            }}
            type="button"
          >
            {truncateText(removeCitations(newsItem.news_title), 150)}
          </button>
        ))}
      </Slider>

      <NewsModal
        newsId={selectedNewsId}
        onClose={handleCloseModal}
        show={showModal}
      />
    </>
  );
};
